import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@material-ui/core";
import { TextField } from "../../TextField/TextField.styled";
import { BriefingFormModel } from "pages/BriefingForm/interfaces";
import { Controller } from "react-hook-form";

export const UserDataSection: React.FC<FieldsHookForm<BriefingFormModel>> = ({ control, errors }) => {
    const { t } = useTranslation();
    return (
        <Box>
            <Box mb={2}>
                <Controller
                    name="salesRep.name"
                    control={control}
                    label={t("briefingForm.label.fullName")}
                    error={!!errors.salesRep?.name}
                    fullWidth
                    as={<TextField />}
                />
                {errors.salesRep?.name && (
                    <Typography variant="body1" color="error">
                        {errors.salesRep?.name?.message}
                    </Typography>
                )}
            </Box>

            <Box display="flex" justifyContent="center">
                <Box display="flex" justifyContent="space-between" width="100%" flexWrap="wrap">
                    <Box>
                        <Controller
                            name="salesRep.phone"
                            control={control}
                            error={!!errors.salesRep?.phone}
                            label={t("briefingForm.label.phoneNumber")}
                            as={<TextField />}
                        />
                        {errors.salesRep?.phone && (
                            <Typography variant="body1" color="error">
                                {errors.salesRep?.phone?.message}
                            </Typography>
                        )}
                    </Box>
                    <Box>
                        <Controller
                            name="salesRep.email"
                            control={control}
                            error={!!errors.salesRep?.email}
                            label={t("briefingForm.label.email")}
                            as={<TextField />}
                        />
                        {errors.salesRep?.email && (
                            <Typography variant="body1" color="error">
                                {errors.salesRep?.email?.message}
                            </Typography>
                        )}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
